var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhantom = function SvgPhantom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phantom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.4 1.6H1.6v12.8h12.8V1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9886E5",
    d: "M16 0H0v16h16V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFDF8",
    fillRule: "evenodd",
    d: "M7.112 9.894c-.538.824-1.439 1.867-2.638 1.867-.567 0-1.112-.233-1.112-1.247 0-2.581 3.525-6.577 6.795-6.577 1.86 0 2.601 1.29 2.601 2.756 0 1.881-1.22 4.033-2.434 4.033-.385 0-.574-.212-.574-.547 0-.088.014-.183.043-.285-.414.708-1.213 1.364-1.962 1.364-.545 0-.82-.343-.82-.824 0-.175.035-.357.1-.54Zm4.418-3.252c0 .427-.252.64-.534.64-.286 0-.533-.213-.533-.64 0-.427.247-.64.534-.64.281 0 .533.213.533.64Zm-1.601 0c0 .427-.252.64-.534.64-.286 0-.534-.213-.534-.64 0-.427.248-.64.534-.64.282 0 .534.213.534.64Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phantom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPhantom;